/* Live-Suche im Such-Drawer: Treffer mit Bild, Preis und Sofort-Hinweis beim Tippen.
   Eigene Suche im Browser (suche-engine.js + suche-index.json). Bei jedem Fehler bleibt die normale Suche. */
(function () {
  'use strict';
  var CFG = window.SHADE_SUCHE || {};
  if (!CFG.index || !window.Engine) return;
  var E = window.Engine, CDN = 'https://cdn.shopify.com/s/files/1/0604/6056/4696/';
  /* AUDIT C3 27.10.2026: /en mit englischen Texten und Produktlinks unter /en */
  var EN = /^\/en(\/|$)/.test(location.pathname);
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function T(de, en) { return EN ? en : de; }
  var state = 'idle', timer = null, cur = -1, panel = null, drawer = null, input = null, form = null;

  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }
  function eur(n) { return Number(n).toLocaleString('de-DE', { maximumFractionDigits: 2 }) + ' €'; }
  function img(r) {
    return r[7] ? '<img src="' + CDN + esc(r[7]) + (r[7].indexOf('?') > -1 ? '&amp;' : '?') + 'width=240" alt="" loading="lazy" decoding="async">'
      : '<span class="ls-ph">' + esc((r[2] || '?').charAt(0).toUpperCase()) + '</span>';
  }

  function load() {
    if (state !== 'idle') return;
    state = 'loading';
    fetch(CFG.index).then(function (r) { return r.json(); }).then(function (d) {
      E.build(d); state = 'ready';
      if (input && input.value.trim()) render(input.value);
    }).catch(function () {
      state = 'failed';
      if (drawer) drawer.classList.remove('ls-active');
      if (panel) { panel.hidden = true; panel.innerHTML = ''; }
    });
  }

  function badge(x, P) {
    var w = P.sizes.concat(P.cloth);
    if (w.length) return x.sz.sof ? '<span class="ls-badge">' + T('Gr. ', 'Size ') + esc(w[0]) + T(' sofort', ' in stock') + '</span>' : '<span class="ls-badge ls-off">' + T('Gr. ', 'Size ') + esc(w[0]) + T(' auf Bestellung', ' on order') + '</span>';
    return x.it.sof.length ? '<span class="ls-badge">' + T('Sofort lieferbar', 'In stock now') + '</span>' : '';
  }
  function chips(P) {
    var c = [];
    P.sizes.concat(P.cloth).forEach(function (s) { c.push(T('Größe ', 'Size ') + s); });
    if (P.sofort) c.push(T('Sofort lieferbar', 'In stock now'));
    if (P.max != null) c.push(T('bis ', 'up to ') + eur(P.max));
    P.fixes.forEach(function (f) { c.push('„' + f[0] + '“ → ' + f[1]); });
    return c.length ? '<div class="ls-chips">' + c.map(function (t) { return '<span>' + esc(t) + '</span>'; }).join('') + '</div>' : '';
  }
  function card(x, P) {
    var r = x.it.r;
    return '<a class="ls-card" role="option" href="' + ROOT + 'products/' + esc(r[0]) + '"><span class="ls-im">' + img(r) + '</span><span class="ls-x"><span class="ls-v">' +
      esc(r[2]) + '</span><span class="ls-n">' + E.hl(r[1], P) + '</span><span class="ls-m"><span class="ls-p">' + T('ab ', 'from ') + eur(r[4]) + '</span>' + badge(x, P) + '</span></span></a>';
  }

  function render(q) {
    if (!panel) return;
    q = String(q || '');
    if (!q.trim()) { drawer.classList.remove('ls-active'); panel.hidden = true; panel.innerHTML = ''; return; }
    if (state === 'failed') return;
    drawer.classList.add('ls-active'); panel.hidden = false;
    if (state !== 'ready') { panel.innerHTML = '<p class="ls-hint">' + T('Suche wird geladen …', 'Loading search …') + '</p>'; return; }
    var R = E.run(q), P = R.P, shown = R, note = '';
    if (!R.total && R.relaxed) {
      shown = R.relaxed.res; P = shown.P;
      note = '<p class="ls-note">' + T('Nichts zu „' + esc(q.trim()) + '“. Das ist am nächsten dran:', 'Nothing for "' + esc(q.trim()) + '". This is the closest:') + '</p>';
    }
    var h = '';
    if (!shown.total) {
      var alt = E.suggestBrands(q, 5);
      h = '<div class="ls-empty"><strong>' + T('Nichts gefunden', 'Nothing found') + '</strong><span>' + T('Prüfe die Schreibweise oder lockere Größe und Preis.', 'Check the spelling or loosen size and price.') + '</span>' +
        (alt.length ? '<div class="ls-sug">' + alt.map(function (b) { return '<button type="button" data-q="' + esc(b.name) + '">' + esc(b.name) + '</button>'; }).join('') + '</div>' : '') + '</div>';
    } else {
      var bs = E.topBrands(shown.list, 4), titles = [];
      shown.list.slice(0, 40).forEach(function (x) { var t = x.it.r[1]; if (titles.length < 5 && titles.indexOf(t) < 0) titles.push(t); });
      h = note + chips(P) + '<div class="ls-grid"><div class="ls-side">' +
        (bs.length > 1 ? '<h4>' + T('Marken', 'Brands') + '</h4>' + bs.map(function (b) { return '<button type="button" class="ls-row" data-q="' + esc(b.name) + '">' + esc(b.name) + '</button>'; }).join('') : '') +
        '<h4>' + T('Vorschläge', 'Suggestions') + '</h4>' + titles.map(function (t) { return '<button type="button" class="ls-row" data-q="' + esc(t) + '">' + E.hl(t, P) + '</button>'; }).join('') +
        '</div><div class="ls-cards" role="listbox">' + shown.list.slice(0, 6).map(function (x) { return card(x, P); }).join('') + '</div></div>' +
        '<button type="button" class="ls-all" data-all>' + T('Alle ' + shown.total.toLocaleString('de-DE') + ' Treffer anzeigen', 'Show all ' + shown.total.toLocaleString('en-GB') + ' results') + '</button>';
    }
    panel.innerHTML = h; cur = -1;
  }

  function items() { return [].slice.call(panel.querySelectorAll('.ls-card')); }
  function mark(i) {
    var l = items(); l.forEach(function (e) { e.classList.remove('ls-cur'); });
    cur = l.length ? (i + l.length) % l.length : -1;
    if (cur >= 0) { l[cur].classList.add('ls-cur'); l[cur].scrollIntoView({ block: 'nearest' }); }
  }

  function wire(d) {
    if (d.__ls) return;
    var inp = d.querySelector('input[name=q]'), frm = d.querySelector('form'), host = frm && frm.querySelector('.search-input');
    if (!inp || !frm || !host) return;
    d.__ls = 1; drawer = d; input = inp; form = frm;
    panel = document.createElement('div'); panel.className = 'ls-panel'; panel.hidden = true;
    host.parentNode.insertBefore(panel, host.nextSibling);
    input.addEventListener('focus', load);
    input.addEventListener('input', function () { load(); clearTimeout(timer); timer = setTimeout(function () { render(input.value); }, 60); });
    input.addEventListener('keydown', function (e) {
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); mark(cur + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); mark(cur - 1); }
      else if (e.key === 'Enter' && cur >= 0) { e.preventDefault(); items()[cur].click(); }
    });
    form.addEventListener('reset', function () { setTimeout(function () { render(''); }, 0); });
    panel.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]');
      if (b) { input.value = b.getAttribute('data-q'); render(input.value); input.focus(); return; }
      if (e.target.closest('[data-all]')) { if (form.requestSubmit) form.requestSubmit(); else form.submit(); }
    });
    if (input.value) render(input.value);
  }

  function init() {
    try { var d = document.querySelector('search-drawer'); if (d) wire(d); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  /* Drawer wird erst beim Öffnen gerendert → nachziehen */
  document.addEventListener('click', function () { setTimeout(init, 60); });
})();
